module.exports = __webpack_public_path__ + "assets/img/addTask_btn1.8c55d234.png";